module.exports = __webpack_public_path__ + "media/iconic/cogs-291d70c5.svg";